export default __webpack_public_path__ + "9dda5f3c1063216e387ecff1a69fcf7e.svg";